import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
const DEFAULT_BUTTON_DATA = {
    background: '#f4e600',
    color: '#2d2d2d',
};
export default defineComponent({
    name: 'BoxPromo',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const { button, subtitle, title, svg = '' } = props.box.data;
        const isCustomButton = computed(() => {
            const HexRegEx = /#[0-9a-f]{6}/i;
            const { background: bg, color } = button || {};
            const { background: defaultBg, color: defaultColor } = DEFAULT_BUTTON_DATA;
            return HexRegEx.test(bg) && HexRegEx.test(color) && (bg !== defaultBg || color !== defaultColor);
        });
        return {
            button,
            css,
            isCustomButton,
            subtitle,
            svg,
            title,
        };
    },
});
